
import Vue from 'vue'
import BinnacleTransformer from './../../transformers/sinister/binnacle'

export default (affectedId, payload) => {
  const transformed = BinnacleTransformer.send(payload)
  return Vue.$http.post(`sinisters/affected/${affectedId}/binnacle/`, transformed)
    .then(response => {
      const data = response.data
      const transformed = BinnacleTransformer.fetch(data)
      return transformed
    })
}


// WEBPACK FOOTER //
// ./src/services/sinister/createBinnacle.js